<template>
    <div
            v-if="params"
            :class="rankedOverlayClasses"
    >
        <div class="ranked-overlay__inner">
            <div class="ranked-overlay__image">
                <img
                        src="/images/ranked-overlay/image_large.png"
                        alt=""
                >
                <div class="ranked-overlay__place">
                    <img
                            v-for="(i, index) in place"
                            :key="index"
                            :src="i"
                    >
                </div>
            </div>
            <div
                    class="ranked-overlay__body"
                    :style="rankedOverlayStyles"
            >
                <div class="ranked-overlay__sr-main">
                    <span>SR</span>
                    {{ params.data.sr }}
                </div>
                <div class="ranked-overlay__delta-text">
                    DELTA - LAST {{ params.data.delta }}
                    <template v-if="params.data.delta === 1">HOUR</template>
                    <template v-else>HOURS</template>
                </div>
                <div class="delta-count">
                    <span class="delta-count__name">SR</span>
                    <span :class="`delta-count__type delta-count__type--is-${params.data.srDelta}`">
            <i class="icon-arrow-up"/>
          </span>
                    <span class="delta-count__text">
            {{ params.data.sr_diff }}
          </span>
                </div>
                <div class="delta-count">
                    <span class="delta-count__name">POSITION</span>
                    <span
                    :class="`delta-count__type delta-count__type--is-${params.data.posDelta}`"
                    >
            <i class="icon-arrow-up"/>
          </span>
                    <span class="delta-count__text">
            {{ params.data.pos }}
          </span>
                </div>
                <div class="delta-count" v-if="game !== 'wz2'">
                    <span class="delta-count__name">WINSTREAK</span>
                    <span class="delta-count__type"/>
                    <span class="delta-count__text">
            {{ params.data.winstreak }}
          </span>
                </div>

                <div class="ranked-overlay__footer">
                    WZHUB.GG<span>/{{ game === 'mw2' ? 'TOP-250' : 'WZR-250' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'WZRankedOverlay',

  props: {
    params: {
      type: Object,
      default: null,
    },

    game: {
      type: String,
      default: 'mw2',
    },

    duration: {
      type: String,
      default: '3000',
    },
  },

  data() {
    return {
      idx: 0,
    };
  },

  computed: {
    rankedOverlayClasses() {
      return [
        'ranked-overlay',
      ];
    },

    rankedOverlayStyles() {
      return {
        background: `rgba(0,0,0, ${this.params.styles.opacity / 10})`,
      };
    },

    place() {
      if (!this.params) {
        return [];
      }
      return this.params.data.place.split('').map((i) => `/images/ranked-overlay/${i}.png`);
    },
  },

  mounted() {

  },

};
</script>

<style lang="scss">

.ranked-overlay {
  $this: '.ranked-overlay';
  padding: 10px 20px 10px 2px;

  position: relative;
  display: inline-block;

  &__inner {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__place {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 62px;
    left: 50%;
    transform: translateX(-50%);
    gap: 5px;

    > img {
      height: 44px;

    }
  }

  &__image {
    position: relative;
    z-index: 2;

    img {
      border: none;
    }
  }

  &__sr-main {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 600;
    color: var(--colors-palette-primary);

    span {
      background: #fff;
      color: #000;
      border-radius: 5px;
      padding: 4px;
      font-size: 12px;
      margin-right: 10px;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    z-index: 1;
    top: 275px;
    width: 190px;
    background: #000;
    border: 3px #1e1e1e solid;
    padding: 15px;
    padding-top: 80px;
    padding-bottom: 40px;
    border-radius: 15px;
    overflow: hidden;
  }

  &__delta-text {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
    opacity: 0.7;
    margin-bottom: 15px;
  }

  .delta-count {
    width: 100%;
    background: #1e1e1e;
    border-radius: 7px;
    font-size: 12px;
    padding: 4px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;

    &__type {
      font-size: 12px;
      margin-right: 5px;

      &--is-positive {
        color: var(--colors-utility-success);
      }

      &--is-negative {
        transform: rotate(180deg);
        color: var(--colors-utility-error);
      }

      i {
        display: flex;
      }
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    &__name {
      margin-right: auto;
      padding: 5px;
      border-radius: 5px;
      color: #acacac;
    }

    &__text {
      color: #d7d7d7;
      font-size: 14px;
    }

  }

  &__footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 10px 0;
    background: #1e1e1e;

    span {
      color: var(--colors-palette-primary);
    }
  }

}

</style>
